module.exports = __webpack_public_path__ + "img/track.e559032b.png";